import React, { useState, useEffect } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import AdminTopBar from '../components/AdminTopBar';
import PanelHelpBadge from '../components/admin/PanelHelpBadge';
import { API_BASE_URL } from '../config';
import axios from 'axios';
import Swal from 'sweetalert2';

const BOOLEAN_CONFIG_KEYS = new Set([
    'ENABLE_AI_RECIPES',
    'ENABLE_ADVERTISEMENTS',
    'ENABLE_PRICING_CRON',
    'ADMIN_ANALYTICS_AI_NARRATIVE_ENABLED',
    'CONSUMPTION_RECIPE_IMMEDIATE_APPLY_ENABLED',
    'CONSUMPTION_MANUAL_ITEM_REVIEW_ENABLED',
    'CONSUMPTION_WEEKLY_REVIEW_ENABLED',
    'CONSUMPTION_AUTO_EXECUTE_ENABLED',
    'KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED',
    'KITCHEN_BEHAVIOR_CANARY_AI_FALLBACK_ENABLED',
    'KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED',
    'KITCHEN_BEHAVIOR_CANARY_REASSURANCE_ENABLED',
    'KITCHEN_BEHAVIOR_CANARY_SCOPE_ENFORCED',
    'KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED',
    'KITCHEN_BEHAVIOR_ENGINE_ENABLED',
    'KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED',
    'KITCHEN_BEHAVIOR_TEXT_LAYER_ENABLED',
    'KITCHEN_DECISION_PROFILE_ENABLED',
    'KITCHEN_DECISION_PROFILE_SHADOW_ONLY'
]);

const CRITICAL_CONFIG_KEYS = new Set([
    'KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED',
    'KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED',
    'KITCHEN_BEHAVIOR_ENGINE_ENABLED',
    'KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED',
    'KITCHEN_DECISION_PROFILE_ENABLED',
    'KITCHEN_DECISION_PROFILE_MAX_DELTA_PERCENT',
    'KITCHEN_DECISION_PROFILE_MAX_INFLUENCE',
    'KITCHEN_DECISION_PROFILE_MIN_SAMPLE',
    'ENABLE_PRICING_CRON',
    'LAST_AI_PRICE_UPDATE',
    'CONSUMPTION_RECIPE_IMMEDIATE_APPLY_ENABLED',
    'CONSUMPTION_RECIPE_REVERT_WINDOW_MINUTES'
]);

const CONFIG_LABELS_TR = {
    ENABLE_PRICING_CRON: 'Market Fiyat Otomasyonu',
    KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED: 'Canary Davranışta Bağlam Yakalama',
    KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED: 'Davranış Motorunda Bağlam Yakalama',
    KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED: 'Davranış Motoru AI Fallback',
    KITCHEN_BEHAVIOR_CANARY_AI_FALLBACK_ENABLED: 'Canary AI Fallback',
    KITCHEN_BEHAVIOR_CANARY_REASSURANCE_ENABLED: 'Canary Güvence Katmanı',
    KITCHEN_BEHAVIOR_CANARY_SCOPE_ENFORCED: 'Canary Kapsam Zorlaması',
    KITCHEN_BEHAVIOR_ENGINE_ENABLED: 'Davranış Motoru Aktif',
    KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED: 'Davranış Motoru Gölge Mod',
    KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED: 'Davranış Metni AI Fallback',
    KITCHEN_BEHAVIOR_TEXT_LAYER_ENABLED: 'Davranış Metin Katmanı',
    KITCHEN_BEHAVIOR_CANARY_SEGMENTS: 'Canary Segment Kapsamı',
    ENABLE_AI_RECIPES: 'AI Tarif Üretimi',
    ENABLE_ADVERTISEMENTS: 'Reklam Gösterimi',
    ADMIN_ANALYTICS_AI_NARRATIVE_ENABLED: 'Analitik AI Anlatımı',
    CONSUMPTION_AUTO_EXECUTE_ENABLED: 'Tüketim Otomatik Çalıştırma',
    CONSUMPTION_MANUAL_ITEM_REVIEW_ENABLED: 'Tüketimde Manuel Satır Onayı',
    CONSUMPTION_RECIPE_IMMEDIATE_APPLY_ENABLED: 'Tarif Tüketimini Anında Uygula',
    CONSUMPTION_WEEKLY_REVIEW_ENABLED: 'Haftalık Tüketim Kontrolü',
    KITCHEN_DECISION_PROFILE_ENABLED: 'Karar Profili Motoru',
    KITCHEN_DECISION_PROFILE_SHADOW_ONLY: 'Karar Profili Sadece Gölge Mod',
    KITCHEN_DECISION_PROFILE_MAX_DELTA_PERCENT: 'Karar Profili Maksimum Delta Yüzdesi',
    KITCHEN_DECISION_PROFILE_MAX_INFLUENCE: 'Karar Profili Maksimum Etki',
    KITCHEN_DECISION_PROFILE_MIN_SAMPLE: 'Karar Profili Minimum Örneklem',
    CONSUMPTION_RECIPE_REVERT_WINDOW_MINUTES: 'Tarif Geri Alma Penceresi (Dakika)',
    LAST_AI_PRICE_UPDATE: 'Son AI Fiyat Güncelleme Zamanı',
    CONSUMPTION_WEEKLY_REVIEW_EXPIRY_DAYS: 'Haftalık Tüketim İnceleme Geçerlilik Günü',
    CONSUMPTION_WEEKLY_REVIEW_INTERVAL_DAYS: 'Haftalık Tüketim İnceleme Aralığı (Gün)',
    CONSUMPTION_WEEKLY_REVIEW_THRESHOLD: 'Haftalık Tüketim İnceleme Eşiği',
    CONSUMPTION_ROLLOUT_STAGE: 'Tüketim Yayın Aşaması',
    CONSUMPTION_STAGED_PERCENT: 'Tüketim Kademeli Yayın Yüzdesi',
    ADMIN_ANALYTICS_FAVORITES_ENABLED: 'Analitik Favoriler Modülü',
    ADMIN_ANALYTICS_INGREDIENT_AFFINITY_ENABLED: 'Analitik Malzeme Yakınlık Modülü',
    ADMIN_ANALYTICS_INSIGHTS_ENABLED: 'Analitik İçgörü Modülü',
    ADMIN_ANALYTICS_REALTIME_ENABLED: 'Analitik Gerçek Zamanlı Modül',
    ADMIN_ANALYTICS_V3_ENABLED: 'Analitik V3 Motoru',
    ANALYTICS_V3_CANARY_ADMIN_IDS: 'Analitik V3 Canary Admin ID Listesi',
    ANALYTICS_V3_ROLLOUT_STAGE: 'Analitik V3 Yayın Aşaması',
    ANALYTICS_V3_STAGED_PERCENT: 'Analitik V3 Kademeli Yayın Yüzdesi'
};

const CONFIG_DESCRIPTIONS_TR = {
    ENABLE_PRICING_CRON: 'Piyasa fiyatlarını arka planda periyodik olarak günceller.',
    KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED: 'Canary aşamasında karar bağlamı kayıtlarını toplar.',
    KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED: 'Davranış motoru kararlarının bağlamını kayıt altına alır.',
    KITCHEN_BEHAVIOR_ENGINE_ENABLED: 'Mutfak davranış motorunun üretim kararlarına katılmasını açar/kapatır.',
    KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED: 'Davranış motorunu kullanıcıya etki etmeden gölge modda çalıştırır.',
    KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED: 'Deterministik metin katmanı uygun metin üretemezse AI metin fallback devreye girer.',
    KITCHEN_DECISION_PROFILE_SHADOW_ONLY: 'Karar profili sadece ölçülür, canlı kararları etkilemez.',
    KITCHEN_DECISION_PROFILE_MAX_DELTA_PERCENT: 'Modelin canlı davranıştan ne kadar sapabileceğini sınırlar.',
    KITCHEN_DECISION_PROFILE_MAX_INFLUENCE: 'Karar profilinin toplam etki katsayısı için üst sınırdır.',
    KITCHEN_DECISION_PROFILE_MIN_SAMPLE: 'Karar profilinin devreye girmesi için gereken minimum örnek sayısıdır.',
    CONSUMPTION_RECIPE_REVERT_WINDOW_MINUTES: 'Tarif tüketimi uygulandıktan sonra geri alma süresini dakika cinsinden belirler.',
    KITCHEN_BEHAVIOR_CANARY_SEGMENTS: 'Canary testinin hangi segmentlerde çalışacağını belirler.',
    CONSUMPTION_WEEKLY_REVIEW_EXPIRY_DAYS: 'Haftalık inceleme kayıtlarının kaç gün geçerli kalacağını belirler.',
    CONSUMPTION_WEEKLY_REVIEW_INTERVAL_DAYS: 'Haftalık tüketim inceleme döngüsünün gün cinsinden aralığını belirler.',
    CONSUMPTION_WEEKLY_REVIEW_THRESHOLD: 'Haftalık inceleme tetik eşiğini belirler.',
    CONSUMPTION_ROLLOUT_STAGE: 'Tüketim akışının hangi rollout aşamasında çalışacağını belirler.',
    CONSUMPTION_STAGED_PERCENT: 'Tüketim özelliğinin kademeli yayın yüzdesini belirler.',
    ADMIN_ANALYTICS_FAVORITES_ENABLED: 'Favori davranışlarına yönelik analitik modülünü açar/kapatır.',
    ADMIN_ANALYTICS_INGREDIENT_AFFINITY_ENABLED: 'Malzeme yakınlığı analitiği modülünü açar/kapatır.',
    ADMIN_ANALYTICS_INSIGHTS_ENABLED: 'Yönetici içgörü kartlarının analitik beslemesini açar/kapatır.',
    ADMIN_ANALYTICS_REALTIME_ENABLED: 'Gerçek zamanlı analitik akışını açar/kapatır.',
    ADMIN_ANALYTICS_V3_ENABLED: 'Analitik V3 hattını aktif/pasif yapar.',
    ANALYTICS_V3_CANARY_ADMIN_IDS: 'Analitik V3 canary testine dahil admin kullanıcı ID listesidir.',
    ANALYTICS_V3_ROLLOUT_STAGE: 'Analitik V3 için rollout seviyesini tanımlar (canary/staged/full).',
    ANALYTICS_V3_STAGED_PERCENT: 'Analitik V3 staged rollout yüzdesini belirler.'
};

const CONFIG_META_TR = {
    KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED: {
        layer: 'ai',
        riskLevel: 'HIGH',
        requiresConfirmation: true,
        impact: 'Deterministik metin katmanı uygun yanıt üretemezse AI metin fallback devreye girer.'
    },
    KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED: {
        layer: 'engine',
        riskLevel: 'HIGH',
        requiresConfirmation: true,
        impact: 'Davranış motorunda deterministic yol yetersizse AI fallback karara katılır.'
    },
    KITCHEN_BEHAVIOR_ENGINE_ENABLED: {
        layer: 'engine',
        riskLevel: 'HIGH',
        requiresConfirmation: true,
        impact: 'Mutfak davranış motorunun canlı karara etkisini açar/kapatır.'
    },
    KITCHEN_DECISION_PROFILE_ENABLED: {
        layer: 'engine',
        riskLevel: 'MEDIUM',
        requiresConfirmation: false,
        impact: 'Karar profili sinyallerini canlı karar akışına dahil eder.'
    },
    ENABLE_PRICING_CRON: {
        layer: 'engine',
        riskLevel: 'MEDIUM',
        requiresConfirmation: false,
        impact: 'Market fiyat otomasyonu zamanlayıcı görevlerinin çalışmasını yönetir.'
    },
    LAST_AI_PRICE_UPDATE: {
        layer: 'display',
        riskLevel: 'LOW',
        requiresConfirmation: false,
        impact: 'Son fiyat güncellemesinin zaman damgasını gösterir.'
    }
};

const BEHAVIOR_PROFILES = {
    conservative: {
        label: 'Temkinli',
        values: {
            KITCHEN_BEHAVIOR_ENGINE_ENABLED: 'false',
            KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED: 'false',
            KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED: 'true',
            KITCHEN_DECISION_PROFILE_ENABLED: 'false',
            KITCHEN_DECISION_PROFILE_SHADOW_ONLY: 'true',
            KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED: 'true'
        }
    },
    balanced: {
        label: 'Dengeli',
        values: {
            KITCHEN_BEHAVIOR_ENGINE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED: 'false',
            KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED: 'true',
            KITCHEN_DECISION_PROFILE_ENABLED: 'true',
            KITCHEN_DECISION_PROFILE_SHADOW_ONLY: 'true',
            KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED: 'true'
        }
    },
    aggressive: {
        label: 'Agresif',
        values: {
            KITCHEN_BEHAVIOR_ENGINE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED: 'true',
            KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED: 'false',
            KITCHEN_DECISION_PROFILE_ENABLED: 'true',
            KITCHEN_DECISION_PROFILE_SHADOW_ONLY: 'false',
            KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED: 'true'
        }
    }
};

const GROUP_LABELS_TR = {
    AI: 'Yapay Zeka Servisleri',
    Auth: 'Kimlik Doğrulama',
    analytics: 'Analitik',
    consumption: 'Tüketim',
    General: 'Genel',
    kitchen_behavior: 'Mutfak Davranışı',
    kitchen_decision: 'Mutfak Kararı',
    pricing: 'Fiyatlandırma'
};

const GROUP_CONTRACTS_TR = {
    AI: {
        purpose: 'AI servis entegrasyonlarını ve model erişimini yönetir.',
        layer: 'ai',
        risk: 'HIGH',
        breakage: 'Yanlış değerlerde tarif üretimi ve AI yanıt akışı bozulabilir.'
    },
    Auth: {
        purpose: 'Kimlik doğrulama ve güvenli erişim ayarlarını yönetir.',
        layer: 'engine',
        risk: 'HIGH',
        breakage: 'Hatalı yapılandırma girişleri engeller veya güvenlik açığı doğurur.'
    },
    analytics: {
        purpose: 'Analitik toplama, AI anlatım ve gözlemleme ayarlarını yönetir.',
        layer: 'analytics',
        risk: 'MEDIUM',
        breakage: 'Yanlış ayarda analiz görünürlüğü düşer veya anlatım sapar.'
    },
    consumption: {
        purpose: 'Tüketim/geri alma ve otomatik uygulama davranışını belirler.',
        layer: 'engine',
        risk: 'HIGH',
        breakage: 'Stok düşümü, geri alma penceresi ve tüketim doğruluğu bozulabilir.'
    },
    General: {
        purpose: 'Genel sistem anahtarlarını ve uygulama davranışını yönetir.',
        layer: 'display',
        risk: 'MEDIUM',
        breakage: 'Kullanıcı deneyimi ve genel görünüm etkilenir.'
    },
    kitchen_behavior: {
        purpose: 'Mutfak davranış motoru, fallback ve canary akışını yönetir.',
        layer: 'engine / ai',
        risk: 'HIGH',
        breakage: 'Deterministik akış fallback ile sapabilir, karar davranışı tutarsızlaşır.'
    },
    kitchen_decision: {
        purpose: 'Karar profili etkisini ve eşiklerini yönetir.',
        layer: 'engine',
        risk: 'HIGH',
        breakage: 'Öneri ve karar katmanında aşırı/agresif sapmalar oluşabilir.'
    },
    pricing: {
        purpose: 'Fiyat güncelleme hattı ve fiyat snapshot davranışını yönetir.',
        layer: 'pricing',
        risk: 'HIGH',
        breakage: 'Fiyat drift, parity bozulması ve yanlış maliyet görünümü oluşabilir.'
    }
};

function getConfigLabel(key) {
    return CONFIG_LABELS_TR[key] || key;
}

function getConfigDescription(config) {
    if (CONFIG_DESCRIPTIONS_TR[config.key]) return CONFIG_DESCRIPTIONS_TR[config.key];
    return config.isSecret ? 'Bu değer güvenlik nedeniyle maskelenmiştir.' : 'Sistem anahtarı.';
}

function humanizeConfigKey(key = '') {
    return String(key)
        .toLowerCase()
        .split('_')
        .filter(Boolean)
        .join(' ');
}

function getConfigHelp(config) {
    const isBoolean = BOOLEAN_CONFIG_KEYS.has(config.key);
    const meta = CONFIG_META_TR[config.key] || {};
    return {
        title: getConfigLabel(config.key),
        description: getConfigDescription(config),
        interpretation: isBoolean
            ? 'Aktif olduğunda bu özellik devreye girer, pasif olduğunda kapanır.'
            : 'Bu alan sistem davranışını belirleyen bir yapılandırma değeridir.',
        metricExample: `Katman: ${meta.layer || 'genel'} | Risk: ${meta.riskLevel || 'LOW'} | Anahtar: ${config.key} (${humanizeConfigKey(config.key)})`
    };
}
export default function AdminConfig() {
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [editValues, setEditValues] = useState({});
    const [selectedProfile, setSelectedProfile] = useState('balanced');
    const [searchQuery, setSearchQuery] = useState('');
    const [onlyCritical, setOnlyCritical] = useState(false);
    const [onlyChangedFromDefault, setOnlyChangedFromDefault] = useState(false);
    const [safeModeSnapshot, setSafeModeSnapshot] = useState(null);
    const [auditLog, setAuditLog] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('adminConfigAuditLog') || '[]');
        } catch {
            return [];
        }
    });

    useEffect(() => {
        fetchConfigs();
    }, []);

    const fetchConfigs = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
            const res = await axios.get(`${API_BASE_URL}/api/admin/config`, {
                withCredentials: true,
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            if (res.data.ok) {
                setConfigs(res.data.configs);
                // Initialize edit values
                const initialValues = {};
                res.data.configs.forEach(c => {
                    initialValues[c.key] = c.value;
                });
                setEditValues(initialValues);
            }
        } catch (err) {
            console.error('Fetch configs error:', err);
            Swal.fire('Hata', 'Ayarlar yüklenemedi', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (key, value) => {
        setEditValues(prev => ({ ...prev, [key]: value }));
    };

    const handleSave = async (group) => {
        try {
            setSaving(true);
            // Filter changes for this group
            const groupConfigs = normalizedConfigs.filter(c => c.group === group);
            const changes = {};
            const riskyChanges = [];
            groupConfigs.forEach(c => {
                if (editValues[c.key] !== c.value) {
                    changes[c.key] = editValues[c.key];
                    const meta = CONFIG_META_TR[c.key];
                    if (meta?.requiresConfirmation || meta?.riskLevel === 'HIGH') {
                        riskyChanges.push(c.key);
                    }
                }
            });

            if (Object.keys(changes).length === 0) {
                Swal.fire('Bilgi', 'Değişiklik yapılmadı', 'info');
                return;
            }

            if (riskyChanges.length > 0) {
                const confirmResult = await Swal.fire({
                    icon: 'warning',
                    title: 'Yüksek Riskli Ayar Değişikliği',
                    html: `<div style="text-align:left">Aşağıdaki anahtarlar yüksek etkili:<br/><br/><b>${riskyChanges.join('<br/>')}</b><br/><br/>Kaydetmek istediğine emin misin?</div>`,
                    showCancelButton: true,
                    confirmButtonText: 'Evet, kaydet',
                    cancelButtonText: 'Vazgeç'
                });
                if (!confirmResult.isConfirmed) {
                    return;
                }
            }

            const token = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
            const res = await axios.patch(`${API_BASE_URL}/api/admin/config/bulk`, {
                configs: changes
            }, {
                withCredentials: true,
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });

            if (res.data.ok) {
                const entry = {
                    id: `log_${Date.now()}`,
                    at: new Date().toISOString(),
                    group,
                    changes
                };
                const nextAudit = [entry, ...auditLog].slice(0, 50);
                setAuditLog(nextAudit);
                localStorage.setItem('adminConfigAuditLog', JSON.stringify(nextAudit));
                Swal.fire('Başarılı', 'Ayarlar güncellendi', 'success');
                fetchConfigs();
            }
        } catch (err) {
            console.error('Save config error:', err);
            Swal.fire('Hata', 'Ayarlar kaydedilemedi', 'error');
        } finally {
            setSaving(false);
        }
    };

    const normalizedConfigs = React.useMemo(() => {
        const list = Array.isArray(configs) ? [...configs] : [];
        const hasPricingCron = list.some((c) => c.key === 'ENABLE_PRICING_CRON');
        if (!hasPricingCron) {
            list.push({
                id: 'virtual_enable_pricing_cron',
                key: 'ENABLE_PRICING_CRON',
                value: String(editValues.ENABLE_PRICING_CRON ?? 'false'),
                group: 'pricing',
                isSecret: false
            });
        }
        return list;
    }, [configs, editValues.ENABLE_PRICING_CRON]);

    const filteredConfigs = React.useMemo(() => {
        const q = searchQuery.trim().toLocaleLowerCase('tr-TR');
        return normalizedConfigs.filter((c) => {
            if (onlyCritical && !CRITICAL_CONFIG_KEYS.has(c.key)) return false;

            if (onlyChangedFromDefault) {
                const baseline = String(c.defaultValue ?? c.initialValue ?? c.value ?? '');
                const current = String(editValues[c.key] ?? c.value ?? '');
                if (current === baseline) return false;
            }

            if (!q) return true;
            const haystack = [
                c.key,
                getConfigLabel(c.key),
                getConfigDescription(c),
                c.group
            ]
                .filter(Boolean)
                .join(' ')
                .toLocaleLowerCase('tr-TR');
            return haystack.includes(q);
        });
    }, [normalizedConfigs, searchQuery, onlyCritical, onlyChangedFromDefault, editValues]);

    const groups = [...new Set(filteredConfigs.map(c => c.group))];

    const pendingChanges = normalizedConfigs.filter((c) => (editValues[c.key] ?? c.value) !== c.value);
    const highRiskPending = pendingChanges.filter((c) => (CONFIG_META_TR[c.key]?.riskLevel || 'LOW') === 'HIGH').length;
    const dashboardAiStatus = String(
        editValues.ADMIN_ANALYTICS_AI_NARRATIVE_ENABLED
            ?? normalizedConfigs.find((c) => c.key === 'ADMIN_ANALYTICS_AI_NARRATIVE_ENABLED')?.value
            ?? 'false'
    ) === 'true';
    const fallbackStatus = String(editValues.KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED ?? normalizedConfigs.find((c) => c.key === 'KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED')?.value ?? 'false') === 'true';
    const pricingCronStatus = String(editValues.ENABLE_PRICING_CRON ?? normalizedConfigs.find((c) => c.key === 'ENABLE_PRICING_CRON')?.value ?? 'false') === 'true';
    const dangerKeys = [
        'KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED',
        'KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED',
        'KITCHEN_DECISION_PROFILE_MAX_DELTA_PERCENT',
        'KITCHEN_DECISION_PROFILE_MAX_INFLUENCE',
        'ENABLE_PRICING_CRON'
    ];
    const dangerRows = dangerKeys
        .map((key) => normalizedConfigs.find((c) => c.key === key))
        .filter(Boolean);

    const applyPreset = (profileKey) => {
        const preset = BEHAVIOR_PROFILES[profileKey];
        if (!preset) return;
        setSelectedProfile(profileKey);
        setEditValues((prev) => {
            const next = { ...prev };
            Object.entries(preset.values).forEach(([k, v]) => {
                next[k] = v;
            });
            return next;
        });
    };
    const getLiveValue = (key, fallback = 'mevcut') => {
        const cfg = normalizedConfigs.find((c) => c.key === key);
        const v = editValues[key] ?? cfg?.value;
        return v ?? fallback;
    };

    const riskStatus = highRiskPending > 0 ? 'Yüksek' : pendingChanges.length > 0 ? 'Orta' : 'Düşük';

    const applySafeMode = () => {
        if (!safeModeSnapshot) {
            setSafeModeSnapshot({ ...editValues });
        }
        setEditValues((prev) => ({
            ...prev,
            KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED: 'false',
            KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED: 'false',
            KITCHEN_BEHAVIOR_ENGINE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_ENGINE_SHADOW_ENABLED: 'true',
            KITCHEN_DECISION_PROFILE_ENABLED: 'false',
            KITCHEN_DECISION_PROFILE_SHADOW_ONLY: 'true',
            KITCHEN_BEHAVIOR_CONTEXT_CAPTURE_ENABLED: 'true',
            KITCHEN_BEHAVIOR_CANARY_CONTEXT_CAPTURE_ENABLED: 'true'
        }));
        Swal.fire('Safe Mode Hazır', 'Önerilen güvenli ayarlar forma uygulandı. Kaydet ile kalıcı hale getir.', 'success');
    };

    const restoreSafeModeSnapshot = () => {
        if (!safeModeSnapshot) return;
        setEditValues(safeModeSnapshot);
        setSafeModeSnapshot(null);
        Swal.fire('Geri Alındı', 'Safe Mode öncesi ayarlar forma geri yüklendi.', 'success');
    };

    return (
        <div className="flex min-h-screen bg-slate-50 dark:bg-[#0d141c]">
            <AdminSidebar mobileOpen={mobileSidebarOpen} onCloseMobile={() => setMobileSidebarOpen(false)} />

            <main className="flex-1 md:ml-[var(--admin-sidebar-width,18rem)] flex flex-col min-h-screen transition-[margin] duration-300">
                <AdminTopBar title="Sistem Ayarları" onToggleMobile={() => setMobileSidebarOpen(true)} />

                <div className="p-4 sm:p-8 flex-1">
                    <header className="mb-8">
                        <h1 className="text-2xl font-black text-slate-800 dark:text-white">Sistem Ayarları</h1>
                        <p className="text-slate-500 text-sm mt-1">Uygulama genelindeki kritik özellikleri ve API anahtarlarını yönetin.</p>
                    </header>

                    <div className="mb-6 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                            <div className="lg:col-span-1">
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Ayar ara: fallback, pricing, decision..."
                                    className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-sm dark:text-white focus:ring-2 focus:ring-primary/20 transition-all"
                                />
                            </div>
                            <div className="lg:col-span-2 flex flex-wrap gap-3">
                                <button
                                    type="button"
                                    onClick={() => setOnlyCritical((v) => !v)}
                                    className={`px-3 py-2 rounded-lg text-xs font-bold border ${
                                        onlyCritical
                                            ? 'bg-red-600 text-white border-red-500'
                                            : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                                    }`}
                                >
                                    {onlyCritical ? '✓ Sadece Kritik' : 'Sadece Kritik'}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setOnlyChangedFromDefault((v) => !v)}
                                    className={`px-3 py-2 rounded-lg text-xs font-bold border ${
                                        onlyChangedFromDefault
                                            ? 'bg-amber-500 text-white border-amber-400'
                                            : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                                    }`}
                                >
                                    {onlyChangedFromDefault ? '✓ Varsayılandan Değişenler' : 'Varsayılandan Değişenler'}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setSearchQuery('');
                                        setOnlyCritical(false);
                                        setOnlyChangedFromDefault(false);
                                    }}
                                    className="px-3 py-2 rounded-lg text-xs font-bold border bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700"
                                >
                                    Filtreleri Temizle
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="mb-6 grid grid-cols-1 lg:grid-cols-4 gap-4">
                        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                            <div className="text-xs text-slate-500">Dashboard AI</div>
                            <div className={`text-sm font-bold ${dashboardAiStatus ? 'text-emerald-500' : 'text-slate-500'}`}>{dashboardAiStatus ? 'Açık' : 'Kapalı'}</div>
                        </div>
                        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                            <div className="text-xs text-slate-500">Fallback</div>
                            <div className={`text-sm font-bold ${fallbackStatus ? 'text-amber-500' : 'text-emerald-500'}`}>{fallbackStatus ? 'Açık' : 'Kapalı'}</div>
                        </div>
                        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                            <div className="text-xs text-slate-500">Market Fiyat Otomasyonu</div>
                            <div className={`text-sm font-bold ${pricingCronStatus ? 'text-emerald-500' : 'text-slate-500'}`}>{pricingCronStatus ? 'Açık' : 'Kapalı'}</div>
                        </div>
                        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                            <div className="text-xs text-slate-500">Bekleyen Riskli Değişiklik</div>
                            <div className={`text-sm font-bold ${highRiskPending > 0 ? 'text-red-500' : 'text-emerald-500'}`}>{highRiskPending}</div>
                        </div>
                        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                            <div className="text-xs text-slate-500">Risk Seviyesi</div>
                            <div className={`text-sm font-bold ${riskStatus === 'Yüksek' ? 'text-red-500' : riskStatus === 'Orta' ? 'text-amber-500' : 'text-emerald-500'}`}>{riskStatus}</div>
                        </div>
                    </div>

                    <div className="mb-8 grid grid-cols-1 xl:grid-cols-2 gap-4">
                        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                            <div className="text-sm font-bold text-slate-800 dark:text-white mb-2">Davranış Profili</div>
                            <div className="flex flex-wrap gap-2">
                                {Object.entries(BEHAVIOR_PROFILES).map(([key, p]) => (
                                    <button
                                        key={key}
                                        type="button"
                                        onClick={() => applyPreset(key)}
                                        className={`px-3 py-1.5 rounded-lg text-xs font-bold border ${
                                            selectedProfile === key
                                                ? 'bg-primary text-white border-primary'
                                                : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                                        }`}
                                    >
                                        {p.label}
                                    </button>
                                ))}
                            </div>
                            <div className="mt-3 text-xs text-slate-500">
                                {(() => {
                                    const p = BEHAVIOR_PROFILES[selectedProfile];
                                    if (!p) return null;
                                    return (
                                        <div className="rounded-lg border border-slate-200 dark:border-slate-700 p-2 bg-slate-50 dark:bg-slate-900/40">
                                            <div className="font-semibold mb-1">{p.label} profili değişiklikleri:</div>
                                            <div>fallback: {String(p.values.KITCHEN_BEHAVIOR_AI_FALLBACK_ENABLED) === 'true' ? 'on' : 'off'}</div>
                                            <div>delta: {p.values.KITCHEN_DECISION_PROFILE_MAX_DELTA_PERCENT ?? getLiveValue('KITCHEN_DECISION_PROFILE_MAX_DELTA_PERCENT')}</div>
                                            <div>influence: {p.values.KITCHEN_DECISION_PROFILE_MAX_INFLUENCE ?? getLiveValue('KITCHEN_DECISION_PROFILE_MAX_INFLUENCE')}</div>
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>
                        <div className="rounded-xl border border-red-200 dark:border-red-900/40 bg-red-50 dark:bg-red-900/20 p-4">
                            <div className="text-sm font-bold text-red-700 dark:text-red-300 mb-1">Acil Güvenli Mod</div>
                            <p className="text-xs text-red-600 dark:text-red-300 mb-3">AI fallback kapatılır, deterministic yol korunur, gözlem açık tutulur.</p>
                            <div className="flex flex-wrap gap-2">
                                <button
                                    type="button"
                                    onClick={applySafeMode}
                                    className="px-3 py-1.5 rounded-lg text-xs font-bold bg-red-600 hover:bg-red-700 text-white"
                                >
                                    Safe Mode Değerlerini Uygula
                                </button>
                                <button
                                    type="button"
                                    onClick={restoreSafeModeSnapshot}
                                    disabled={!safeModeSnapshot}
                                    className="px-3 py-1.5 rounded-lg text-xs font-bold bg-slate-700 hover:bg-slate-800 text-white disabled:opacity-50"
                                >
                                    Geri Al
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="mb-8 rounded-xl border border-red-200 dark:border-red-900/40 bg-red-50 dark:bg-red-900/20 p-4">
                        <div className="text-sm font-bold text-red-700 dark:text-red-300 mb-2">Danger Zone</div>
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            {dangerRows.map((cfg) => {
                                const v = String(editValues[cfg.key] ?? cfg.value ?? '');
                                const isBool = BOOLEAN_CONFIG_KEYS.has(cfg.key);
                                return (
                                    <div key={`danger_${cfg.key}`} className="rounded-lg border border-red-200 dark:border-red-800/40 bg-white/70 dark:bg-[#151f2b]/70 p-3">
                                        <div className="text-xs font-bold text-slate-700 dark:text-slate-200">{getConfigLabel(cfg.key)}</div>
                                        <div className="text-xs text-slate-500 break-all">{cfg.key}</div>
                                        <div className="mt-1 text-xs font-semibold text-red-600 dark:text-red-300">
                                            {isBool ? (v === 'true' ? 'Aktif' : 'Pasif') : v || '-'}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {loading ? (
                        <div className="flex justify-center p-12">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                        </div>
                    ) : (
                        <div className="space-y-8">
                            {groups.map(group => (
                                <div key={group} className="bg-white dark:bg-[#151f2b] rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-visible">
                                    <div className="p-6 border-b border-slate-100 dark:border-slate-800/50 flex justify-between items-center bg-slate-50/50 dark:bg-white/5">
                                        <h2 className="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
                                            <span className="material-symbols-outlined text-primary">
                                                {group === 'AI' ? 'psychology' : group === 'Auth' ? 'lock' : 'settings'}
                                            </span>
                                            {GROUP_LABELS_TR[group] || group}
                                        </h2>
                                        <button
                                            onClick={() => handleSave(group)}
                                            disabled={saving}
                                            className="px-4 py-1.5 bg-primary hover:bg-primary-dark text-white rounded-lg text-sm font-bold transition-all disabled:opacity-50"
                                        >
                                            {saving ? 'Kaydediliyor...' : 'Kaydet'}
                                        </button>
                                    </div>
                                    {GROUP_CONTRACTS_TR[group] && (
                                        <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-800/40 bg-slate-50/40 dark:bg-slate-900/20">
                                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 text-xs">
                                                <div><span className="font-bold text-slate-700 dark:text-slate-200">Ne yapar:</span> <span className="text-slate-600 dark:text-slate-400">{GROUP_CONTRACTS_TR[group].purpose}</span></div>
                                                <div><span className="font-bold text-slate-700 dark:text-slate-200">Katman:</span> <span className="text-slate-600 dark:text-slate-400">{GROUP_CONTRACTS_TR[group].layer}</span></div>
                                                <div><span className="font-bold text-slate-700 dark:text-slate-200">Risk:</span> <span className="text-slate-600 dark:text-slate-400">{GROUP_CONTRACTS_TR[group].risk}</span></div>
                                                <div><span className="font-bold text-slate-700 dark:text-slate-200">Yanlış kullanım:</span> <span className="text-slate-600 dark:text-slate-400">{GROUP_CONTRACTS_TR[group].breakage}</span></div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="p-6 space-y-6">
                                        {(() => {
                                            const groupConfigs = filteredConfigs
                                                .filter((c) => c.group === group)
                                                .sort((a, b) => {
                                                    if (group !== 'pricing') return 0;
                                                    if (a.key === 'ENABLE_PRICING_CRON') return -1;
                                                    if (b.key === 'ENABLE_PRICING_CRON') return 1;
                                                    return 0;
                                                });

                                            return groupConfigs.map((config) => {
                                                const help = getConfigHelp(config);
                                                return (
                                                    <div key={config.id} className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start pb-6 border-b border-slate-50 dark:border-slate-800/30 last:border-0 last:pb-0">
                                                <div className="md:col-span-1">
                                                    <label className="inline-flex items-center gap-2 text-sm font-bold text-slate-700 dark:text-slate-300 mb-1">
                                                        <span>{getConfigLabel(config.key)}</span>
                                                        {(CONFIG_META_TR[config.key]?.riskLevel || 'LOW') === 'HIGH' && (
                                                            <span className="px-1.5 py-0.5 text-[10px] font-black rounded bg-red-100 dark:bg-red-900/40 text-red-600 dark:text-red-300">Yüksek Risk</span>
                                                        )}
                                                        <PanelHelpBadge
                                                            title={help.title}
                                                            description={help.description}
                                                            interpretation={help.interpretation}
                                                            metricExample={help.metricExample}
                                                            side="right"
                                                        />
                                                    </label>
                                                    <p className="text-xs text-slate-500">
                                                        {getConfigDescription(config)}
                                                    </p>
                                                </div>
                                                <div className="md:col-span-2 relative">
                                                    {config.key === 'ENABLE_PRICING_CRON' || config.key === 'KITCHEN_BEHAVIOR_AI_TEXT_FALLBACK_ENABLED' ? (
                                                        <button
                                                            type="button"
                                                            role="switch"
                                                            aria-checked={String(editValues[config.key] ?? config.value ?? 'false') === 'true'}
                                                            onClick={async () => {
                                                                const current = String(editValues[config.key] ?? config.value ?? 'false') === 'true';
                                                                if (group === 'kitchen_behavior' || (CONFIG_META_TR[config.key]?.riskLevel || 'LOW') === 'HIGH') {
                                                                    const result = await Swal.fire({
                                                                        icon: 'warning',
                                                                        title: 'Emin misin?',
                                                                        text: 'Bu ayar sistemi etkiler. Değişikliği uygulamak istiyor musun?',
                                                                        showCancelButton: true,
                                                                        confirmButtonText: 'Evet, değiştir',
                                                                        cancelButtonText: 'Vazgeç'
                                                                    });
                                                                    if (!result.isConfirmed) return;
                                                                }
                                                                handleChange(config.key, current ? 'false' : 'true');
                                                            }}
                                                            className={`relative inline-flex h-8 w-16 items-center rounded-full transition-colors border ${
                                                                String(editValues[config.key] ?? config.value ?? 'false') === 'true'
                                                                    ? 'bg-emerald-500 border-emerald-400'
                                                                    : 'bg-slate-600 border-slate-500'
                                                            }`}
                                                        >
                                                            <span
                                                                className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${
                                                                    String(editValues[config.key] ?? config.value ?? 'false') === 'true'
                                                                        ? 'translate-x-9'
                                                                        : 'translate-x-1'
                                                                }`}
                                                            />
                                                            <span className="sr-only">{getConfigLabel(config.key)}</span>
                                                        </button>
                                                    ) : BOOLEAN_CONFIG_KEYS.has(config.key) ? (
                                                        <select
                                                            value={editValues[config.key] ?? config.value ?? 'true'}
                                                            onChange={(e) => handleChange(config.key, e.target.value)}
                                                            className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-sm dark:text-white focus:ring-2 focus:ring-primary/20 transition-all appearance-none cursor-pointer"
                                                        >
                                                            <option value="true">Aktif</option>
                                                            <option value="false">Pasif</option>
                                                        </select>
                                                    ) : (
                                                        <>
                                                            <input
                                                                type={config.isSecret ? "password" : "text"}
                                                                value={editValues[config.key] || ''}
                                                                onChange={(e) => handleChange(config.key, e.target.value)}
                                                                placeholder={config.isSecret ? "Maskelenmiş Değer" : "Değer giriniz..."}
                                                                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-sm dark:text-white focus:ring-2 focus:ring-primary/20 transition-all"
                                                            />
                                                            {config.isSecret && editValues[config.key] === '********' && (
                                                                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                                                                    <span className="material-symbols-outlined text-slate-400 text-sm">visibility_off</span>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                    </div>
                                                );
                                            });
                                        })()}
                                    </div>
                                </div>
                            ))}

                            {/* Special Controls (Passive) */}
                            <div className="bg-white dark:bg-[#151f2b] rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden p-6 opacity-60">
                                <div className="flex items-start justify-between gap-6">
                                    <div className="flex-1">
                                        <div className="flex items-center gap-2 mb-1">
                                            <span className="font-bold text-slate-800 dark:text-white">Bölgesel Fiyatlandırma</span>
                                            <span className="px-2 py-0.5 bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 text-[10px] font-black rounded uppercase tracking-wider">Devre Dışı</span>
                                        </div>
                                        <p className="text-sm text-slate-500 leading-relaxed">
                                            Kullanıcı adreslerine dayalı anonim pattern havuzu. Gereksinim: 10.000+ Aktif Kullanıcı.
                                        </p>
                                    </div>
                                    <div className="relative inline-flex items-center cursor-not-allowed">
                                        <div className="w-11 h-6 bg-slate-200 dark:bg-slate-700 rounded-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {!loading && groups.length === 0 && (
                        <div className="mt-6 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-6 text-sm text-slate-500">
                            Filtreye uygun ayar bulunamadı.
                        </div>
                    )}

                    <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-900/30 flex gap-3">
                        <span className="material-symbols-outlined text-blue-600 mt-0.5">info</span>
                        <p className="text-xs text-blue-700 dark:text-blue-300 leading-relaxed">
                            <strong>Güvenlik Uyarısı:</strong> Değişiklik yaptığınızda servisleri yeniden başlatmanıza gerek kalmaz, ancak açık olan oturumlarda değişikliğin yansıması 5 dakikaya kadar sürebilir (Önbellek süresi).
                        </p>
                    </div>

                    <div className="mt-6 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#151f2b] p-4">
                        <div className="text-sm font-bold text-slate-800 dark:text-white mb-2">Config Değişiklik Geçmişi (Yerel)</div>
                        {auditLog.length === 0 ? (
                            <div className="text-xs text-slate-500">Henüz kayıt geçmişi yok.</div>
                        ) : (
                            <div className="space-y-2 max-h-48 overflow-auto">
                                {auditLog.slice(0, 10).map((row) => (
                                    <div key={row.id} className="text-xs p-2 rounded border border-slate-200 dark:border-slate-700">
                                        <div className="font-semibold">{row.group} • {new Date(row.at).toLocaleString('tr-TR')}</div>
                                        <div className="text-slate-500 dark:text-slate-400 break-all">{Object.keys(row.changes || {}).join(', ')}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}


